import {
  ADD_SHORTLIST_STONE,
  SET_CC_MODE_CONSUMER_SESSION,
  SET_CC_MODE_PARAMETER_PERMISSIONS,
  SET_CC_MODE_PLAN_FEATURES,
  SET_CC_MODE_SETTING,
  SET_CC_MODE_SETTING_ALLOW_CURRENCY_CHANGE,
  UPDATE_SHORTLIST_STONE_COUNT,
} from "./common.actions";

let initState = {
  shortlistStoneCount: 0,
  shortlistStone: []
};

export const ShortlistStoneReducer = (state = initState, action) => {
  switch (action.type) {
    case UPDATE_SHORTLIST_STONE_COUNT: {
      return {
        ...state,
        shortlistStoneCount: action.payload?.shortListedStoneCount,
      };
    }
    case ADD_SHORTLIST_STONE: {
      return {
        ...state,
        shortlistStone: action.payload,
      };
    }
    default:
      return state;
  }
};

let ccModeSettingInitState = {
  hideCertificateNumber: 0,
  hideEstimatedShippingDays: 0,
  hidePrice: 0,
  displayName: null,
  displaybuybtn:0,
  displayNatural: 0,
  displayLab: 0,
  startSession: 0,
  cartNotification: 0,
  allowCurrencyChange: 1,
  isBuyRequest: 0,
  enableShare: 1,
  shareViaText: 1,
  shareViaWhatsapp: 1,
  shareViaEmail: 1,
};

export const CcModeSettingReducer = (
  state = ccModeSettingInitState,
  action
) => {
  switch (action.type) {
    case SET_CC_MODE_SETTING: {
      return {
        ...state,
        hideCertificateNumber: action.payload?.hideCertificateNumber,
        hideEstimatedShippingDays: action.payload?.hideEstimatedShippingDays,
        hidePrice: action.payload?.hidePrice,
        displayName: action.payload?.displayName,
        displaybuybtn: action.payload?.displaybuybtn,
        displayNatural: action.payload?.displayNatural,
        displayLab: action.payload?.displayLab,
        startSession: action.payload?.startSession,
        cartNotification: action.payload?.cartNotification,
        isBuyRequest: action.payload?.isBuyRequest,
        enableShare: action.payload?.enableShare ?? 1,
        shareViaText: action.payload?.shareViaText ?? 1,
        shareViaWhatsapp: action.payload?.shareViaWhatsapp ?? 1,
        shareViaEmail: action.payload?.shareViaEmail ?? 1
      };
    }
    case SET_CC_MODE_SETTING_ALLOW_CURRENCY_CHANGE: {
      return {
        ...state,
        allowCurrencyChange: action.payload?.allowCurrencyChange
      };
    }
    default:
      return state;
  }
};

let ccModeParameterPermisisonsInitState = {
  "brand": true,
  "milky": true,
  "shade": true,
  "origin": true,
  "eyeClean": true,
  "treatment": true,
  "keyToSymbol": true,
  "secondary": true
};

export const CcModeParameterPermisisonsReducer = (
  state = ccModeParameterPermisisonsInitState,
  action
) => {
  switch (action.type) {
    case SET_CC_MODE_PARAMETER_PERMISSIONS: {
      return {
        ...state,
        brand: action.payload?.brand,
        milky: action.payload?.milky,
        shade: action.payload?.shade,
        origin: action.payload?.origin,
        eyeClean: action.payload?.eyeClean,
        treatment: action.payload?.treatment,
        keyToSymbol: action.payload?.keyToSymbol,
        secondary: action.payload?.secondary,
      };
    }
    default:
      return state;
  }
};

let CcmodeConsumerSessionInitialState = {
  consumerSessionDetails: null
};
export const CcmodeConsumerSessionReducer = (state = CcmodeConsumerSessionInitialState, action) => {
  switch (action.type) {
    case SET_CC_MODE_CONSUMER_SESSION: {
      return {
        ...state,
        consumerSessionDetails: action.payload?.consumerSessionDetails
      }
    }
    default:
      return state
  }
}

let CcmodePlanFeaturesInitialState = {
  planFeatures: null
};
export const CcmodePlanFeaturesReducer = (state = CcmodePlanFeaturesInitialState, action) => {
  switch (action.type) {
    case SET_CC_MODE_PLAN_FEATURES: {
      return {
        ...state,
        planFeatures: action.payload?.planFeatures
      }
    }
    default:
      return state
  }
}